function splitStickerName(stickerPath) {
  const stickerPathList = stickerPath.split('/');
  return stickerPathList[stickerPathList.length - 1].split('.')[0];
};

export default splitStickerName;